<!-- Динамик со звуковыми волнами для воспроизведения звука. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M11 5L6 9H3V15H6L11 19V5Z"
      :stroke="stroke"
      stroke-width="1.8"
      stroke-linejoin="round"
    />
    <path
      d="M15 8A6 6 0 0 1 15 16M18 5A10 10 0 0 1 18 19"
      :stroke="stroke"
      stroke-width="1.8"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "SpeakerIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
